import { AnnotationControls } from "@/components/flow/build/AnnotationControls";
import { Chip } from "@scripts/react/components/Chip";
import { BuildSteps } from "@/types/flows";
import { useFlowState } from "@/hooks/useFlowState";

export const FileControls = ({
    filename,
    flowLocked,
    isShareMode = false
}: {
    filename?: string;
    flowLocked: boolean;
    isShareMode?: boolean;
}) => {
    const { flow, step } = useFlowState();
    const isReviewStep = flow === "build" && step === BuildSteps.REVIEW;

    return (
        <div className="fileCarouselHeader">
            <div className="flex items-center gap-2">
                <h3 className="text-xs font-medium text-primary">
                    {filename || "No file selected"}
                </h3>
                {(flowLocked || isReviewStep) && (
                    <Chip color="gray" type="text" size="small" className="!text-secondary">
                        <i className="fa fa-pencil-slash" />
                        View Only
                    </Chip>
                )}
            </div>
            <AnnotationControls />
        </div>
    );
};
